module.exports = __webpack_public_path__ + "static/media/Jerly.3eaad2c0.jpeg";